import React, { useEffect, useState, useRef } from 'react';
//import { Link, useNavigate } from "react-router-dom";
import { httpRequest, httpAuthHeaders } from '../../services/httpService';
import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
import Loader from '../parts/Loader';
//import InputText from '../elements/InputText';
import RenderErrors from '../elements/RenderErrors';
import InputTextArea from '../elements/InputTextArea';
import ButtonGroupSelection from '../elements/ButtonGroupSelection';
import store from '../../services/store';
import helpers from '../../services/helpers';
import { getApiData } from '../../services/apiService';
import Swal from 'sweetalert2';
import { InputMask } from 'primereact/inputmask';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
         
 
export default function AddressFormModal ({
        reference_id = '', 
        is_show = false, 
        setShow, 
        handleSave, 
        header_title="Address",
        //src="customer",
        origin="customer",
        store_id="",
        index="",
        address_data={},
        direct_save
    }){
    let default_data = {
        "id": "",
        "reference_id": "",
        "address_type_id": 3,
        "contact_name": "",
        "phone_no": "",
        "email": "",
        "address": "",
        "state_code": "",
        "state": "",
        "city_code": "",
        "city": "",
        "barangay_code": "",
        "barangay": "",
        "flag":"new"
    }
    const toast = useRef(null);
    const main_domain = helpers.getMainDomain()
    const [loading, setLoading] = useState(0);
    const [notice, setNotice] = useState('');
    const [record_data, setRecordData] = useState(default_data);
    const [record_loaded, setRecordLoaded] = useState(0);
    const [errors, setErrors] = useState([]);
    const [provinces, setProvinces] = useState([]);
    const [cities, setCities] = useState([]);
    const [barangays, setBarangays] = useState([]);
   
    useEffect(() => {
        setErrors([])
        
        if(origin=="store" && is_show) {
            fetchData()
        }
        else if(is_show && address_data) {
            setRecordData(address_data)
            fetchCities()
        }
        else{
            setRecordData(default_data)
            fetchCities()
        }
    }, [is_show, address_data]);
   
    useEffect(() => {
        if(record_data.city_code) {
            fetchBarangays()

            // const city = helpers.filterObject(cities, record_data.city_code, 'code')
            // setRecordData(prev => ({
            //     ...prev,
            //     'city': city?.name
            // }))
        }
    }, [record_data.city_code]);
   
    useEffect(() => {
        // if(record_data.barangay_code) {
        //     const barangay = helpers.filterObject(barangays, record_data.barangay_code, 'code')
        //     setRecordData(prev => ({
        //         ...prev,
        //         'barangay': barangay?.name
        //     }))
        // }
    }, [record_data.barangay_code]);
   
    useEffect(() => {
        setErrors([])
    }, [record_data]);
    

    function fetchData(){
        if(!reference_id){
            return
        }
        const url = helpers.createUrl(`V1/manage/store/address/${reference_id}?store_id=${helpers.getStoreID()}`)

        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            setRecordData(res)
            setLoading(0)
            setRecordLoaded(1)
            fetchCities()
        })
        .catch((err) => {
            setLoading(0)
            setRecordLoaded(0)

            Swal.fire({
                //title: err.message,
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    
                }
            })
        }); 
    }

    async function fetchCities(){
        setLoading(1)
        const endpoint = helpers.createUrl(`V1/enums/cities`)
        const res = await getApiData(endpoint, false)
                
        if(res.status === 'error'){
            Swal.fire({
                title: "Error!",
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    //reset();
                    //close_modal(0);
                }
            })
        }
        else{
            setCities(res)
            setLoading(0)
        }
    }

    async function fetchBarangays(){
        setLoading(1)
        const endpoint = helpers.createUrl(`V1/enums/barangays?city_municipal_code=${record_data.city_code}`)
        const res = await getApiData(endpoint, false)
                
        if(res.status === 'error'){
            Swal.fire({
                title: "Error!",
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    //reset();
                    //close_modal(0);
                }
            })
        }
        else{
            setBarangays(res)
            setLoading(0)
        }
    }
    
    function inputChange(e,) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            value = 0;
            
            if (e.target.checked) value = 1;
        }

        let new_state = { [name]: value }

        setRecordData({ ...record_data, ...new_state });
    }

    function validateForm(){
        let new_errors = {...errors}
        let variant_errors = 0;

        if(origin !== 'store'){
            if(!record_data.address_type_id){
                new_errors['address_type_id'] = ['The address type field is required.']
            }
            else{
                delete new_errors['address_type_id'];
            }
        }

        if(!record_data.address){
            new_errors['address'] = ['The address field is required.']
        }
        else{
            delete new_errors['address'];
        }

        if(!record_data.contact_name){
            new_errors['contact_name'] = ['The contact name field is required.']
        }
        else{
            delete new_errors['contact_name'];
        }

        setErrors(new_errors);

        return new_errors;
    }

    function handleSubmit(e) {
        const validate = validateForm();
        if(Object.keys(validate).length){
            toast.current.show({severity:'error', detail:'Please complete all required fields in the form.', life: 5000});
            // Swal.fire({
            //     text: 'Please complete all required fields in the form.',
            //     icon: "error",
            //     confirmButtonText: "OK",
            // })
            return
        }

        if(origin !== 'store'){
            setShow(0);
            let form_data = {...record_data}
            form_data.customer_id = reference_id
            //form_data.phone_no = helpers.removeString(record_data.phone_no)
            if(record_data.phone_no){
                form_data.phone_no = helpers.removeString(record_data.phone_no)
            }
    
            if(reference_id){
                form_data.flag = 'edit'
            }

            handleSave(form_data, index)
        }
        else{
            setLoading(1)
    
            let url = helpers.createUrl('V1/manage/store/address')

            if(reference_id && record_loaded){
                url = helpers.createUrl(`V1/manage/store/address/${reference_id}`)
            }

            let form_data = {...record_data}
            form_data.store_id = helpers.getStoreID()
            if(record_data.phone_no){
                form_data.phone_no = helpers.removeString(record_data.phone_no)
            }
            
            delete form_data.flag
            delete form_data.reference_id
            delete form_data.address_type_id
    
            httpRequest(url, 'POST', {
                postdata: form_data,
            }, true)
                .then((res) => {
                    form_data.id = res.id
                    setLoading(0)
                    setShow(0);
    
                    Swal.fire({
                        title: "Success",
                        text: res.message,
                        icon: "success",
                        confirmButtonText: "OK",
                    })
                    .then((result) => {
                        if (result.isConfirmed) {
                            //close_modal(0);
                            setShow(0);
                            handleSave(form_data);
                            return;
                        }
                    })
                })
                .catch((err) => {
                    console.log(err)
                    setLoading(0)
                    
                    if(err.data){
                        setErrors( err.data );
                    }else{
                        setErrors([])
                    }
    
                    Swal.fire({
                        //title: err.message,
                        text: err.message,
                        icon: "error",
                        confirmButtonText: "OK",
                    })
                }); 
        }
    }

    function handleClose(e) {
        reset();
        setShow(0);
    }

    function reset(){
        setRecordData([])
        setNotice('')
    }

    const footerContent = (
        <div>
            <Button label="Save" className='rounded' icon="fas fa-check" onClick={(e) => handleSubmit(1)} autoFocus />
        </div>
    );

    return (
        <>
            <Toast ref={toast} position="top-center" />
            <Dialog 
                visible={is_show} 
                position="top" 
                header={header_title} 
                style={{ width: '50vw' }} 
                breakpoints={{ 
                    '960px': '75vw', // On Tablet (screen < 960px), use 75% width
                    '641px': '95vw'  // On Mobile (screen < 641px), use 95% width
                }}
                onHide={handleClose} 
                footer={footerContent}
            >
                <Loader isLoading={loading}/>

                    {
                    origin !== 'store' ?
                    <div className="row">
                        <div className="col-md-4">
                            <label>Type</label>
                        </div>
                        <div className="col-md-8 form-group">
                            <ButtonGroupSelection
                                tagClass="form-control"
                                id="address_type_id"
                                name='address_type_id' 
                                value={record_data.address_type_id}  
                                onChange={inputChange}
                                onFocus=""
                                optionList={store.contact_address_type}
                                optionProps ={{value:'id', label:'label'}}
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="address_type_id" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div> : ''
                    }
                    <div className="row">
                        <div className="col-md-4">
                            <label>Contact Name<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8 form-group">
                            <InputText
                                id="contact_name" 
                                name="contact_name" 
                                value={record_data.contact_name}
                                tagClass="form-control mb-0"
                                placeholder="Full Name"
                                onChange={inputChange}
                                className='w-100'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="contact_name" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    
                    {
                        origin === "customer" && main_domain === "alsamart.com" && main_domain === "sanricardoshipping.com" ?
                        <>
                            <div className="row">
                                <div className="col-md-4">
                                    <label>City/Municipal</label>
                                </div>
                                <div className="col-md-8 form-group">
                                    <Dropdown  
                                        name='city_code'
                                        value={record_data.city_code} 
                                        onChange={(e) =>
                                            setRecordData(prev => ({
                                                ...prev,
                                                'city_code': e.value
                                            }))
                                        } 
                                        options={cities} 
                                        optionLabel="name" 
                                        optionValue="code" 
                                        placeholder="Select City/Municipal" 
                                        className="w-100" 
                                        checkmark={true} 
                                        highlightOnSelect={false}
                                        filterInputAutoFocus={true}
                                        appendTo="self"
                                        showClear
                                        filter 
                                    />
                                    <RenderErrors 
                                        errors={errors} 
                                        name="city_code" 
                                        className="text-danger"
                                        style={{fontSize: '.9rem'}}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <label>Barangay</label>
                                </div>
                                <div className="col-md-8 form-group">
                                    <Dropdown  
                                        name='barangay_code'
                                        value={record_data.city_code ? record_data.barangay_code : ''} 
                                        onChange={(e) =>
                                            setRecordData(prev => ({
                                                ...prev,
                                                'barangay_code': e.value
                                            }))
                                        } 
                                        options={barangays} 
                                        optionLabel="name" 
                                        optionValue="code" 
                                        placeholder="Select Barangay" 
                                        className="w-100" 
                                        checkmark={true} 
                                        highlightOnSelect={false}
                                        filterInputAutoFocus={true}
                                        disabled={!record_data.city_code || loading}
                                        appendTo="self"
                                        showClear
                                        filter 
                                    />
                                    <RenderErrors 
                                        errors={errors} 
                                        name="barangay_code" 
                                        className="text-danger"
                                        style={{fontSize: '.9rem'}}
                                    />
                                </div>
                            </div>
                        </> : ''
                    }
                    <div className="row">
                        <div className="col-md-4">
                            <label>Complete Address<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8 form-group">
                            <InputTextArea
                                id="address" 
                                name="address" 
                                value={record_data.address}  
                                tagClass="form-control"
                                onChange={inputChange}
                                placeholder='Complete Address'
                                rows={2}
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="address" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label>Email</label>
                        </div>
                        <div className="col-md-8 form-group">
                            <InputText
                                id="email" 
                                name="email" 
                                value={record_data.email}
                                tagClass="form-control mb-0"
                                placeholder="Email"
                                onChange={inputChange}
                                type="email"
                                keyfilter="email"
                                className='w-100'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="email" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label>Phone No</label>
                        </div>
                        <div className="col-md-8">
                            <InputMask 
                                id="phone_no" 
                                name="phone_no" 
                                mask="9999-999-9999" 
                                value={record_data.phone_no}
                                placeholder="0920-321-5468"
                                onChange={inputChange}
                                className='w-100'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="phone_no" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
            </Dialog>
            {/* <Modal show={is_show}>
                <Modal.Header className='pt-3 pb-3'>
                    <h5 className='mb-0'>{header_title}</h5>
                    <Button variant="danger" size="sm" onClick={handleClose}><i className="fas fa-times"></i></Button>
                </Modal.Header>
                <Modal.Body  style={{position: 'relative'}} className='px-4'>
                    <Loader isLoading={loading}/>

                    {
                    origin !== 'store' ?
                    <div className="row">
                        <div className="col-md-4">
                            <label>Type</label>
                        </div>
                        <div className="col-md-8 form-group">
                            <ButtonGroupSelection
                                tagClass="form-control"
                                id="address_type_id"
                                name='address_type_id' 
                                value={record_data.address_type_id}  
                                onChange={inputChange}
                                onFocus=""
                                optionList={store.contact_address_type}
                                optionProps ={{value:'id', label:'label'}}
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="address_type_id" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div> : ''
                    }
                    <div className="row">
                        <div className="col-md-4">
                            <label>Contact Name<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8 form-group">
                            <InputText
                                id="contact_name" 
                                name="contact_name" 
                                value={record_data.contact_name}
                                tagClass="form-control mb-0"
                                placeholder="Full Name"
                                onChange={inputChange}
                                className='w-100'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="contact_name" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label>Complete Address<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8 form-group">
                            <InputTextArea
                                id="address" 
                                name="address" 
                                value={record_data.address}  
                                tagClass="form-control"
                                onChange={inputChange}
                                placeholder='Complete Address'
                                rows={2}
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="address" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label>City/Municipal<span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8 form-group">
                            <Dropdown  
                                name='city'
                                value={record_data.city} 
                                onChange={(e) =>
                                    console.log(e)
                                    // setRecordData(prev => ({
                                    //     ...prev,
                                    //     city: status
                                    // }))
                                } 
                                options={cities} 
                                optionLabel="name" 
                                optionValue="code" 
                                placeholder="Select City/Municipal" 
                                className="w-100" 
                                checkmark={true} 
                                highlightOnSelect={false}
                                showClear
                                filter 
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="city" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label>Email</label>
                        </div>
                        <div className="col-md-8 form-group">
                            <InputText
                                id="email" 
                                name="email" 
                                value={record_data.email}
                                tagClass="form-control mb-0"
                                placeholder="Email"
                                onChange={inputChange}
                                type="email"
                                keyfilter="email"
                                className='w-100'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="email" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label>Phone No</label>
                        </div>
                        <div className="col-md-8">
                            <InputMask 
                                id="phone_no" 
                                name="phone_no" 
                                mask="9999-999-9999" 
                                value={record_data.phone_no}
                                placeholder="0920-321-5468"
                                onChange={inputChange}
                                className='w-100'
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="phone_no" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type='button' className='btn btn-success ml-3 ' onClick={(e) => handleSubmit(1)}><i className="fas fa-check mr-2" />Save</button>  
                </Modal.Footer>
            </Modal> */}
        </>
    )
}